import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const Window = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />

			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/travel-portal-window-mobile-app.png')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					WINDOW APP DEVELOPMENT
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					WINDOW APP DEVELOPMENT
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Window App Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/windows.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Windows Phones are on track of being one of the most popular
								smart phones on the market today. Ever since November of 2015,
								we have been using the SDK for Windows mobile application
								development and have mastered it successfully.
							</p>
							<br />
							<p>
								Experts at Windows Phone Apps Development:- We are experts at
								using Windows Mobile App Developer Tools for developing and
								optimizing a wide array of applications. Our skills and
								adaption’s with these tools enable us to make interactive and
								user friendly Windows Phone 10 applications. Our skilled
								technical team is able to design and create applications that
								are above and beyond what you would expect.
							</p>

							<br />
							<p>
								Windows phone is slowly gaining traction among users and
								hardware manufacturers. The operating system has seen a slew of
								updates with increasingly mature functionality. This means that
								you might have a substantial number of users on this platform.
								These users like other mobile users will want apps right in.
								Because windows Mobile app development is technically similar to
								developing windows desktop apps you want to select a developer
								who:-
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default Window;
